import React from "react";
import { Route, RouteProps } from "react-router-dom";

const Login = React.lazy(() => import("../pages/auth/Login"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
const Confirm = React.lazy(() => import("../pages/auth/Confirm"));
const AdminActivate = React.lazy(() => import("../pages/auth/AdminActivate"));
const ResendEmail = React.lazy(() => import("../pages/auth/ResendEmail"));
const VerifyEmail = React.lazy(() => import("../pages/auth/VerifyEmail"));
const VerifyEmailChange = React.lazy(
  () => import("../pages/auth/VerifyEmailChange")
);
const PasswordReset = React.lazy(() => import("../pages/auth/ChangePassword"));
const ForgetPassword = React.lazy(() => import("../pages/auth/ForgetPassword"));
const EmailSent = React.lazy(() => import("../pages/auth/EmailSent"));
const Register = React.lazy(() => import("../pages/auth/Register"));
const SignInSignUp = React.lazy(() => import("../pages/auth/SignInSignUp"));
const LockScreen = React.lazy(() => import("../pages/auth/LockScreen"));

const NotificationList = React.lazy(
  () => import("../pages/moga/notifications/NotificationsPage")
);

const RequestList = React.lazy(() => import("../pages/moga/requests/Requests"));
const RequestAdd = React.lazy(
  () => import("../pages/moga/requests/RequestAdd")
);
const RequestUpdate = React.lazy(
  () => import("../pages/moga/requests/RequestEdit")
);

const ExpeditionList = React.lazy(
  () => import("../pages/moga/expeditions/Expeditions")
);
const ExpeditionAdd = React.lazy(
  () => import("../pages/moga/expeditions/ExpeditionAdd")
);
const ExpeditionUpdate = React.lazy(
  () => import("../pages/moga/expeditions/ExpeditionEdit")
);

const ProductList = React.lazy(() => import("../pages/moga/products/Products"));
const ProductAdd = React.lazy(
  () => import("../pages/moga/products/ProductAdd")
);

const StockList = React.lazy(() => import("../pages/moga/stock/Stock"));
const StockEntityStats = React.lazy(
  () => import("../pages/moga/stock/StockEntityStats")
);
const StockMovementsPage = React.lazy(
  () => import("../pages/moga/stock/StockMovements")
);
const ProductUpdate = React.lazy(
  () => import("../pages/moga/products/ProductEdit")
);

const AffiliateList = React.lazy(
  () => import("../pages/moga/affiliates/Affiliates")
);

const AffiliatesSellers = React.lazy(
  () => import("../pages/moga/affiliates/AffiliatesSellers")
);

const AffiliateAdd = React.lazy(
  () => import("../pages/moga/affiliates/AffiliateAdd")
);
const AffiliateUpdate = React.lazy(
  () => import("../pages/moga/affiliates/AffiliateEdit")
);

const InvoicesList = React.lazy(
  () => import("../pages/moga/invoices/Invoices")
);

const InvoiceView = React.lazy(
  () => import("../pages/moga/invoices/InvoiceView")
);

const InvoiceEdit = React.lazy(
  () => import("../pages/moga/invoices/InvoiceEdit")
);

const OrdersList = React.lazy(() => import("../pages/moga/orders/Orders"));
const OrdersAdd = React.lazy(() => import("../pages/moga/orders/OrderAdd"));
const OrdersUpdate = React.lazy(() => import("../pages/moga/orders/OrderEdit"));
const MyQueue = React.lazy(() => import("../pages/moga/orders/MyQueue"));
const AiConfirmation = React.lazy(
  () => import("../pages/moga/aiConfirmation/AiConfirmation")
);
const AgentsPerformance = React.lazy(
  () => import("../pages/moga/agents/AgentsPerformance")
);
const DeliveryFees = React.lazy(() => import("../pages/moga/deliveryFees/DeliveryFees"));

const PackagesList = React.lazy(
  () => import("../pages/moga/packages/Packages")
);
const PackagesAdd = React.lazy(
  () => import("../pages/moga/packages/PackageAdd")
);
const PackagesUpdate = React.lazy(
  () => import("../pages/moga/packages/PackageEdit")
);

const CalculatorApp = React.lazy(
  () => import("../pages/moga/calculator/Calculator")
);

const ShippingsList = React.lazy(
  () => import("../pages/moga/shippings/Shippings")
);
const DeliveryShipping = React.lazy(
  () => import("../pages/moga/shippings/DeliveryShipping")
);
const UsersList = React.lazy(() => import("../pages/moga/users/Users"));
const Settings = React.lazy(() => import("../pages/moga/settings/Settings"));
const UserProfile = React.lazy(() => import("../pages/moga/users/UserProfile"));
const UsersAdd = React.lazy(() => import("../pages/moga/users/UserAdd"));
const UsersEdit = React.lazy(() => import("../pages/moga/users/UserEdit"));

const TransferOrderListPage = React.lazy(() => import("../pages/moga/transferOrders/TransferOrderList"));
const TransferOrderAddPage  = React.lazy(() => import("../pages/moga/transferOrders/TransferOrderAdd"));
const TransferOrderDetailPage = React.lazy(() => import("../pages/moga/transferOrders/TransferOrderDetail"));
const StockTransfersPage = React.lazy(() => import("../pages/moga/stockTransfers/StockTransfers"));

const SourcingDashboardPage = React.lazy(() => import("../pages/moga/sourcing/SourcingDashboard"));
const SourcingRequestsPage = React.lazy(() => import("../pages/moga/sourcing/SourcingRequests"));
const SourcingExpeditionPage = React.lazy(() => import("../pages/moga/sourcing/SourcingExpedition"));

const PointagePage = React.lazy(() => import("../pages/moga/presence/Pointage"));
const SupportCases = React.lazy(() => import("../pages/moga/support/SupportCases"));
const NotepadPage = React.lazy(() => import("../pages/moga/notepad/Notepad"));
const LogsList = React.lazy(() => import("../pages/moga/logs/Logs"));
const LogView = React.lazy(() => import("../pages/moga/logs/LogView"));
const EmailLogsPage = React.lazy(
  () => import("../pages/moga/emailLogs/EmailLogs")
);

const BoutiquesPage = React.lazy(
  () => import("../pages/moga/boutiques/Boutiques")
);
const DashboardBoutiquesPage = React.lazy(
  () => import("../pages/dashboard/DashboardBoutiques")
);
const IntegrationManagement = React.lazy(
  () => import("../pages/moga/integrations/IntegrationManagement")
);
const WebhookLogsPage = React.lazy(
  () => import("../pages/moga/integrations/WebhookLogs")
);
const FlexioDispatchHealth = React.lazy(
  () => import("../pages/moga/integrations/FlexioDispatchHealth")
);
const IntegrationSuccess = React.lazy(
  () => import("../pages/moga/integrations/IntegrationSuccess")
);
const IntegrationError = React.lazy(
  () => import("../pages/moga/integrations/IntegrationError")
);
const Privacy = React.lazy(() => import("../pages/legal/Privacy"));

const Dashboard = React.lazy(() => import("../pages/dashboard/Dashboard"));
const PlatformStatsPage = React.lazy(() => import("../pages/dashboard/PlatformStatsPage"));

const AccountingPage = React.lazy(
  () => import("../pages/moga/accounting/Accounting")
);
const OwnerFinancePage = React.lazy(
  () => import("../pages/moga/accounting/OwnerFinance")
);

const MySellersPage = React.lazy(
  () => import("../pages/moga/accountManager/MySellers")
);
const MyCommissionsPage = React.lazy(
  () => import("../pages/moga/accountManager/MyCommissions")
);
const AgentCommissionsPage = React.lazy(
  () => import("../pages/moga/agentCommissions/AgentCommissions")
);

const DriverInvoicesList = React.lazy(
  () => import("../pages/moga/driverInvoices/DriverInvoices")
);
const DriverInvoiceForm = React.lazy(
  () => import("../pages/moga/driverInvoices/DriverInvoiceForm")
);
const DriverInvoiceView = React.lazy(
  () => import("../pages/moga/driverInvoices/DriverInvoiceView")
);

export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
}

const dashboardRoutes: RoutesProps = {
  path: "/dashboard",
  name: "Dashboard",
  roles: ["admin", "seller", "moderator"],
  icon: "airplay",
  element: <Dashboard />,
};

const platformStatsRoute: RoutesProps = {
  path: "/statistics",
  name: "Platform statistics",
  roles: ["admin", "moderator", "supervisor"],
  icon: "bar-chart-2",
  element: <PlatformStatsPage />,
};

const ordersAddRoute: RoutesProps = {
  path: "/orders/add",
  name: "Order add",
  roles: ["admin", "seller", "agent", "moderator", "supervisor"],
  element: <OrdersAdd />,
};

const calculatorRoute: RoutesProps = {
  path: "/calculator",
  name: "Calculator",
  roles: ["admin", "seller", "moderator", "supervisor"],
  icon: "briefcase",
  element: <CalculatorApp />,
};

const ordersEditRoute: RoutesProps = {
  path: "/orders/edit/:id",
  name: "Order Edit",
  roles: ["admin", "seller", "agent", "moderator", "supervisor"],
  element: <OrdersUpdate />,
};

const ordersListAppRoutes: RoutesProps = {
  path: "/orders/list",
  name: "Orders",
  roles: ["admin", "seller", "agent", "moderator", "supervisor"],
  icon: "calendar",
  element: <OrdersList />,
};

const myQueueRoute: RoutesProps = {
  path: "/orders/my-queue",
  name: "My Queue",
  roles: ["agent", "moderator", "supervisor", "admin"],
  icon: "alarm-check",
  element: <MyQueue />,
};

const aiConfirmationRoute: RoutesProps = {
  path: "/orders/ai-confirmation",
  name: "AI Confirmation",
  roles: ["admin", "seller", "agent", "moderator", "supervisor"],
  icon: "cpu",
  element: <AiConfirmation />,
};

const agentsPerformanceRoute: RoutesProps = {
  path: "/agents/performance",
  name: "Agent performance",
  roles: ["moderator", "supervisor", "admin"],
  icon: "activity",
  element: <AgentsPerformance />,
};

const deliveryFeesRoute: RoutesProps = {
  path: "/delivery-fees/list",
  name: "Delivery fees",
  roles: ["agent", "moderator", "supervisor", "admin"],
  icon: "dollar-sign",
  element: <DeliveryFees />,
};

const affiliatesAddRoute: RoutesProps = {
  path: "/affiliates/add",
  name: "Affiliate add",
  roles: ["admin"],
  element: <AffiliateAdd />,
};

const affiliatesEditRoute: RoutesProps = {
  path: "/affiliates/edit/:id",
  name: "Affiliate Edit",
  roles: ["admin"],
  element: <AffiliateUpdate />,
};

const affiliatesListAppRoutes: RoutesProps = {
  path: "/affiliates/list",
  name: "Affiliates",
  roles: ["admin", "moderator", "supervisor"],
  icon: "calendar",
  element: <AffiliateList />,
};

const packagesAddRoute: RoutesProps = {
  path: "/packages/add",
  name: "Packages add",
  roles: ["admin"],
  element: <PackagesAdd />,
};

const packagesEditRoute: RoutesProps = {
  path: "/packages/edit/:id",
  name: "Packages Edit",
  roles: ["admin"],
  element: <PackagesUpdate />,
};

const packagesListAppRoutes: RoutesProps = {
  path: "/packages/list",
  name: "Packages",
  roles: ["admin"],
  icon: "calendar",
  element: <PackagesList />,
};

const affiliatesSellersAppRoutes: RoutesProps = {
  path: "/affiliates/store",
  name: "Marketplace",
  roles: ["admin", "seller", "moderator", "supervisor"],
  icon: "calendar",
  element: <AffiliatesSellers />,
};

const invoicesListAppRoutes: RoutesProps = {
  path: "/invoices/list",
  name: "Invoices",
  roles: ["admin", "seller", "moderator"],
  icon: "invoice",
  element: <InvoicesList />,
};

const InvoicesViewRoute: RoutesProps = {
  path: "/invoices/view/:id",
  name: "Invoices",
  roles: ["admin", "seller", "moderator"],
  icon: "invoice",
  element: <InvoiceView />,
};

const InvoicesEditRoute: RoutesProps = {
  path: "/invoices/edit/:id",
  name: "Invoices",
  roles: ["admin"],
  icon: "invoice",
  element: <InvoiceEdit />,
};

const requestsAddRoute: RoutesProps = {
  path: "/requests/add",
  name: "Request add",
  roles: ["admin", "seller"],
  element: <RequestAdd />,
};

const NotificationListRoutes: RoutesProps = {
  path: "/notifications",
  name: "Notifications",
  roles: ["admin", "seller", "agent", "moderator", "supervisor", "delivery", "sourcing_agent"],
  icon: "calendar",
  element: <NotificationList />,
};

const requestsEditRoute: RoutesProps = {
  path: "/requests/edit/:id",
  name: "Request Edit",
  roles: ["admin", "moderator", "supervisor"],
  element: <RequestUpdate />,
};

const requestsListAppRoutes: RoutesProps = {
  path: "/requests/list",
  name: "Requests",
  roles: ["admin", "seller", "moderator", "supervisor"],
  icon: "calendar",
  element: <RequestList />,
};

const expeditionsAddRoute: RoutesProps = {
  path: "/expeditions/add",
  name: "Expedition add",
  roles: ["admin", "seller"],
  element: <ExpeditionAdd />,
};

const expeditionsEditRoute: RoutesProps = {
  path: "/expeditions/edit/:id",
  name: "Expedition Edit",
  roles: ["admin", "seller", "moderator", "supervisor"],
  element: <ExpeditionUpdate />,
};

const expeditionsListListAppRoutes: RoutesProps = {
  path: "/expeditions/list",
  name: "Expeditions",
  roles: ["admin", "seller", "moderator", "supervisor"],
  icon: "calendar",
  element: <ExpeditionList />,
};

const productsAddRoute: RoutesProps = {
  path: "/products/add/:affiliateId",
  name: "Products add",
  roles: ["admin", "seller", "moderator", "supervisor"],
  element: <ProductAdd />,
};

const productEditRoute: RoutesProps = {
  path: "/products/edit/:id",
  name: "Products Edit",
  roles: ["admin", "seller", "moderator", "supervisor"],
  element: <ProductUpdate />,
};

const productListListAppRoutes: RoutesProps = {
  path: "/products/list",
  name: "Products",
  roles: ["admin", "seller", "moderator", "supervisor"],
  icon: "calendar",
  element: <ProductList />,
};

const stockListAppRoutes: RoutesProps = {
  path: "/stock/list",
  name: "Stock",
  roles: ["admin"],
  icon: "layers",
  element: <StockList />,
};

const stockEntityStatsRoute: RoutesProps = {
  path: "/stock/stats/:kind/:id",
  name: "Stock statistics",
  roles: ["admin", "seller", "moderator", "supervisor"],
  element: <StockEntityStats />,
};

const stockMovementsRoute: RoutesProps = {
  path: "/stock/movements",
  name: "Stock movements",
  roles: ["admin", "seller", "moderator", "supervisor"],
  icon: "activity",
  element: <StockMovementsPage />,
};

const shippingListAppRoutes: RoutesProps = {
  path: "/shippings/list",
  name: "Shippings",
  roles: ["admin", "agent", "seller", "delivery", "moderator", "supervisor"],
  icon: "truck",
  element: <ShippingsList />,
};

const deliveryShippingRoute: RoutesProps = {
  path: "/shippings/delivery/list",
  name: "Shipping list",
  roles: ["admin", "delivery"],
  element: <DeliveryShipping />,
};

const usersListAppRoutes: RoutesProps = {
  path: "/users/list",
  name: "Users",
  roles: ["admin", "supervisor"],
  icon: "users",
  element: <UsersList />,
};

const settingsRoute: RoutesProps = {
  path: "/settings",
  name: "Settings",
  roles: ["admin"],
  icon: "settings",
  element: <Settings />,
};

const usersAddRoute: RoutesProps = {
  path: "/users/add",
  name: "Users add",
  roles: ["admin", "supervisor"],
  element: <UsersAdd />,
};

const userEditRoute: RoutesProps = {
  path: "/users/edit/:id",
  name: "Users Edit",
  roles: ["admin"],
  element: <UsersEdit />,
};

const userProfileRoute: RoutesProps = {
  path: "/users/profile",
  name: "My Profile",
  roles: ["admin", "seller", "agent", "moderator", "supervisor", "delivery", "sourcing_agent"],
  element: <UserProfile />,
};

const pointageRoute: RoutesProps = {
  path: "/pointage",
  name: "Pointage",
  roles: ["agent", "delivery"],
  icon: "check-square",
  element: <PointagePage />,
};

const sourcingDashboardRoute: RoutesProps = {
  path: "/sourcing/dashboard",
  name: "Sourcing Dashboard",
  roles: ["sourcing_agent"],
  element: <SourcingDashboardPage />,
};

const sourcingRequestsRoute: RoutesProps = {
  path: "/sourcing/requests",
  name: "Sourcing Requests",
  roles: ["sourcing_agent"],
  element: <SourcingRequestsPage />,
};

const sourcingExpeditionRoute: RoutesProps = {
  path: "/sourcing/expedition",
  name: "Sourcing Expedition",
  roles: ["sourcing_agent"],
  element: <SourcingExpeditionPage />,
};

const transferOrdersListRoute: RoutesProps = {
  path: "/transfer-orders/list",
  name: "Transfer Orders",
  roles: ["agent", "admin", "moderator", "supervisor"],
  element: <TransferOrderListPage />,
};

const transferOrdersAddRoute: RoutesProps = {
  path: "/transfer-orders/add",
  name: "New Transfer Order",
  roles: ["agent", "admin", "moderator", "supervisor"],
  element: <TransferOrderAddPage />,
};

const transferOrdersDetailRoute: RoutesProps = {
  path: "/transfer-orders/:id",
  name: "Transfer Order Detail",
  roles: ["agent", "admin", "moderator", "supervisor"],
  element: <TransferOrderDetailPage />,
};

const stockTransfersListRoute: RoutesProps = {
  path: "/stock-transfers/list",
  name: "Stock Transfers",
  roles: ["admin", "moderator", "supervisor"],
  icon: "shuffle",
  element: <StockTransfersPage />,
};

const supportCasesListAppRoutes: RoutesProps = {
  path: "/support/list",
  name: "Support & claims",
  roles: ["seller", "admin", "supervisor", "moderator"],
  icon: "life-buoy",
  element: <SupportCases />,
};

const notepadAppRoutes: RoutesProps = {
  path: "/notepad",
  name: "Bloc-notes",
  roles: ["admin", "agent", "moderator", "seller"],
  icon: "edit-3",
  element: <NotepadPage />,
};

const logsListAppRoutes: RoutesProps = {
  path: "/logs/list",
  name: "Logs",
  roles: ["admin", "supervisor"],
  icon: "activity",
  element: <LogsList />,
};

const logViewRoute: RoutesProps = {
  path: "/logs/view/:id",
  name: "Log View",
  roles: ["admin", "supervisor"],
  element: <LogView />,
};

const emailLogsRoute: RoutesProps = {
  path: "/email-logs",
  name: "Email logs",
  roles: ["admin"],
  icon: "mail",
  element: <EmailLogsPage />,
};

const boutiquesRoute: RoutesProps = {
  path: "/boutiques",
  name: "My boutiques",
  roles: ["seller"],
  icon: "shopping-bag",
  element: <BoutiquesPage />,
};

const dashboardBoutiquesRoute: RoutesProps = {
  path: "/dashboard/boutiques",
  name: "Performance by boutique",
  roles: ["seller"],
  icon: "bar-chart-2",
  element: <DashboardBoutiquesPage />,
};

const integrationsRoute: RoutesProps = {
  path: "/integrations",
  name: "Integrations",
  roles: ["admin", "seller"],
  icon: "link",
  element: <IntegrationManagement />,
};

const webhookLogsRoute: RoutesProps = {
  path: "/integrations/logs",
  name: "Webhook Logs",
  roles: ["admin", "seller"],
  element: <WebhookLogsPage />,
};

const flexioDispatchRoute: RoutesProps = {
  path: "/integrations/flexio-dispatch",
  name: "FlexioPage Dispatch",
  roles: ["admin"],
  element: <FlexioDispatchHealth />,
};

const accountingRoute: RoutesProps = {
  path: "/accounting",
  name: "Accounting",
  roles: ["admin"],
  icon: "book",
  element: <AccountingPage />,
};

const ownerFinanceRoute: RoutesProps = {
  path: "/finance/owner",
  name: "Owner finances",
  roles: ["admin"],
  icon: "trending-up",
  element: <OwnerFinancePage />,
};

const mySellersRoute: RoutesProps = {
  path: "/account-manager/sellers",
  name: "My sellers",
  roles: ["admin", "account_manager"],
  icon: "users",
  element: <MySellersPage />,
};

const myCommissionsRoute: RoutesProps = {
  path: "/account-manager/commissions",
  name: "My commissions",
  roles: ["admin", "account_manager"],
  icon: "dollar-sign",
  element: <MyCommissionsPage />,
};

const agentCommissionsRoute: RoutesProps = {
  path: "/agent-commissions",
  name: "Agent Commissions",
  roles: ["admin", "supervisor"],
  icon: "dollar-sign",
  element: <AgentCommissionsPage />,
};

const driverInvoicesListRoute: RoutesProps = {
  path: "/driver-invoices/list",
  name: "Driver invoices",
  roles: ["admin", "supervisor", "agent", "moderator", "delivery"],
  icon: "credit-card",
  element: <DriverInvoicesList />,
};

const driverInvoicesAddRoute: RoutesProps = {
  path: "/driver-invoices/add",
  name: "New driver invoice",
  roles: ["admin", "supervisor", "agent"],
  element: <DriverInvoiceForm />,
};

const driverInvoicesEditRoute: RoutesProps = {
  path: "/driver-invoices/edit/:id",
  name: "Edit driver invoice",
  roles: ["admin", "supervisor", "agent"],
  element: <DriverInvoiceForm />,
};

const driverInvoicesViewRoute: RoutesProps = {
  path: "/driver-invoices/view/:id",
  name: "Driver invoice",
  roles: ["admin", "supervisor", "agent", "moderator", "delivery"],
  element: <DriverInvoiceView />,
};

const appRoutes: RoutesProps[] = [];

const authRoutes: RoutesProps[] = [
  {
    path: "/auth/login",
    name: "Login",
    element: <Login />,
    route: Route,
  },
  {
    path: "/auth/register",
    name: "Register",
    element: <Register />,
    route: Route,
  },
  {
    path: "/auth/confirm",
    name: "Confirm",
    element: <Confirm />,
    route: Route,
  },
  {
    path: "/auth/activate",
    name: "Activate",
    element: <AdminActivate />,
    route: Route,
  },

  {
    path: "/auth/resend-email",
    name: "Resend-Email",
    element: <ResendEmail />,
    route: Route,
  },
  {
    path: "/auth/verify-email/:emailToken",
    name: "Verify-Email",
    element: <VerifyEmail />,
    route: Route,
  },
  {
    path: "/auth/verify-email-change/:emailToken",
    name: "Verify-Email-Change",
    element: <VerifyEmailChange />,
    route: Route,
  },
  {
    path: "/auth/password-reset/:token",
    name: "Password-Reset",
    element: <PasswordReset />,
    route: Route,
  },
  {
    path: "/auth/forget-password",
    name: "Forget Password",
    element: <ForgetPassword />,
    route: Route,
  },
  {
    path: "/auth/email-sent",
    name: "Email Sent",
    element: <EmailSent />,
    route: Route,
  },
  {
    path: "/auth/signin-signup",
    name: "SignIn-SignUp",
    element: <SignInSignUp />,
    route: Route,
  },
  {
    path: "/auth/lock-screen",
    name: "Lock Screen",
    element: <LockScreen />,
    route: Route,
  },
  {
    path: "/auth/logout",
    name: "Logout",
    element: <Logout />,
    route: Route,
  },
];

const otherPublicRoutes = [
  {
    path: "/integrations/error",
    name: "Integration Error",
    element: <IntegrationError />,
    route: Route,
  },
  {
    path: "/integrations/success",
    name: "Integration Success",
    element: <IntegrationSuccess />,
    route: Route,
  },
  {
    path: "/privacy",
    name: "Privacy",
    element: <Privacy />,
    route: Route,
  },
];

const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  routes.forEach((item: RoutesProps) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

const authProtectedRoutes = [
  dashboardRoutes,
  platformStatsRoute,
  dashboardBoutiquesRoute,
  boutiquesRoute,
  integrationsRoute,
  webhookLogsRoute,
  flexioDispatchRoute,
  productListListAppRoutes,
  stockListAppRoutes,
  stockEntityStatsRoute,
  stockMovementsRoute,
  logsListAppRoutes,
  emailLogsRoute,
  supportCasesListAppRoutes,
  notepadAppRoutes,
  expeditionsListListAppRoutes,
  requestsListAppRoutes,
  affiliatesListAppRoutes,
  affiliatesSellersAppRoutes,
  usersListAppRoutes,
  settingsRoute,
  invoicesListAppRoutes,
  shippingListAppRoutes,
  ordersListAppRoutes,
  myQueueRoute,
  aiConfirmationRoute,
  agentsPerformanceRoute,
  deliveryFeesRoute,
  calculatorRoute,
  packagesListAppRoutes,
  pointageRoute,
  transferOrdersListRoute,
  stockTransfersListRoute,
  accountingRoute,
  ownerFinanceRoute,
  agentCommissionsRoute,
  driverInvoicesListRoute,
  mySellersRoute,
  myCommissionsRoute,
  sourcingDashboardRoute,
  sourcingRequestsRoute,
  sourcingExpeditionRoute,
  productEditRoute,
  ...appRoutes,
];

const myRoutes = [
  usersAddRoute,
  deliveryShippingRoute,
  userEditRoute,
  userProfileRoute,
  logViewRoute,
  productsAddRoute,
  packagesEditRoute,
  packagesAddRoute,
  expeditionsAddRoute,
  expeditionsEditRoute,
  requestsAddRoute,
  requestsEditRoute,
  NotificationListRoutes,
  InvoicesViewRoute,
  InvoicesEditRoute,
  affiliatesAddRoute,
  affiliatesEditRoute,
  ordersAddRoute,
  ordersEditRoute,
  transferOrdersAddRoute,
  transferOrdersDetailRoute,
  driverInvoicesAddRoute,
  driverInvoicesEditRoute,
  driverInvoicesViewRoute,
];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];
const otherRouter = flattenRoutes([...myRoutes]);

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export {
  otherRouter,
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
